import { render, staticRenderFns } from "./TableListTags.vue?vue&type=template&id=567bc5d8"
import script from "./TableListTags.vue?vue&type=script&lang=js"
export * from "./TableListTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports